export const mountDashboardLink = (id: number, spanFilter: string, dashboard: LiveDashboard): string => {
    if (!id || !dashboard) return ''

    return `#/dashboard/${id}/?mode=view&span=${spanFilter}`
}
